export default "__VITE_ASSET__DvuN0hOw__"